<a [routerLink]="" class="normalLogo">
    <img src="{{ IMAGES.LOGO_BLACK }}" class="logo" alt="LOGO_BLACK" />
</a>